/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledAssessmentProposalConflictsRequest model module.
 * @module model/ScheduledAssessmentProposalConflictsRequest
 * @version 1.0.0
 */
class ScheduledAssessmentProposalConflictsRequest {
    /**
     * Constructs a new <code>ScheduledAssessmentProposalConflictsRequest</code>.
     * @alias module:model/ScheduledAssessmentProposalConflictsRequest
     * @param propertyIds {Array.<Number>} チェック対象の物件 ID（最大 10000 件）。査定提案は物件単位で作成するため物件 ID で指定する。
     * @param proposalDate {Date} 予約したい日時。この日時と同じ暦日（JST）の予約を重複とみなす。
     */
    constructor(propertyIds, proposalDate) { 
        
        ScheduledAssessmentProposalConflictsRequest.initialize(this, propertyIds, proposalDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, propertyIds, proposalDate) { 
        obj['property_ids'] = propertyIds;
        obj['proposal_date'] = proposalDate;
    }

    /**
     * Constructs a <code>ScheduledAssessmentProposalConflictsRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledAssessmentProposalConflictsRequest} obj Optional instance to populate.
     * @return {module:model/ScheduledAssessmentProposalConflictsRequest} The populated <code>ScheduledAssessmentProposalConflictsRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledAssessmentProposalConflictsRequest();

            if (data.hasOwnProperty('property_ids')) {
                obj['property_ids'] = ApiClient.convertToType(data['property_ids'], ['Number']);
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledAssessmentProposalConflictsRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledAssessmentProposalConflictsRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ScheduledAssessmentProposalConflictsRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['property_ids'])) {
            throw new Error("Expected the field `property_ids` to be an array in the JSON data but got " + data['property_ids']);
        }

        return true;
    }


}

ScheduledAssessmentProposalConflictsRequest.RequiredProperties = ["property_ids", "proposal_date"];

/**
 * チェック対象の物件 ID（最大 10000 件）。査定提案は物件単位で作成するため物件 ID で指定する。
 * @member {Array.<Number>} property_ids
 */
ScheduledAssessmentProposalConflictsRequest.prototype['property_ids'] = undefined;

/**
 * 予約したい日時。この日時と同じ暦日（JST）の予約を重複とみなす。
 * @member {Date} proposal_date
 */
ScheduledAssessmentProposalConflictsRequest.prototype['proposal_date'] = undefined;






export default ScheduledAssessmentProposalConflictsRequest;

